export const DOCUMENT_ID_PARAM = ':documentId';
export const DOCUMENT_VERSION_PARAM = ':documentVersion';

export const DOCUMENT_RESULTS_PAGE = `/results/${DOCUMENT_ID_PARAM}/${DOCUMENT_VERSION_PARAM}`;

export const NOT_FOUND_PAGE = '/404';
